import { iconClass } from '../StyleHelpers';
export type ValidationState = boolean|"unmounted";

export interface IValidatorcomponentNameAndId
{
    name: string,
    id: string
}

export interface IComponentErrorMessage
{
    errorMsg: string,
    componentName: string 
}
export interface IActionButton extends IActionButtonIdentifier {
    executing?: boolean,
    id?: string;    
    baseText?: string,
    baseClass?: string,
    disabled: boolean,
    clickEvent: (input : IActionButtonIdentifier |undefined) => void,
    width?: number,
    toolTip?: string,
    iconClass?: string,
    spinText?: string, 
    spinClass?: string,
    overRideStyle?: ActionButtonStyle,
    executeInit?: boolean
}
export interface IActionButtonIdentifier {
    id?: string;
    baseText?: string
}

export const textBaseClass: string = "textual_button";
export const billingBaseClass: string = "btn btn-outline-primary btn-sm text-start";
export const spinnerClass: string = "spinner-border";
export const spinnerClassSmall: string = "spinner-border spinner-border-sm";  
export type IActionButtons = IActionButton[];

    export enum ActionButtonStyle {
    Base = "Base",
    Save = "Save",
    Post = "Post",
    Complete = "Complete",
    Add = "Add",
    Delete = "Delete",
    Remove = "Remove",
    Export = "Export",
    Import = "Import",
    Close = "Close",
    Report = "Report",
    Edit = "Edit",
    Ignore = "Ignore",
    Warning = "Warning",
    Reverse = "Reverse",
    Hold = "Hold",
    Calendar = "Calendar",
    Communication = "Communication",
    Receipt = "Receipt",
    Invoice = "Invoice",
    InvoiceDollar = "InvoiceDollar",
    Statement = "Statement",
    Send = "Send",
    Excel = "Excel",
    Print = "Print",
    Setting = "Setting",
    Customize = "Customize",
    Tools = "Tools",
    Search = "Search",
    Location = "Location",
    Next = "Next",
    Forward = "Forward",
    Last = "Last",
    Previous = "Previous",
    Backward = "Backward",
    First = "First",
    Lock = "Lock",
    Unlock = "Unlock",
    Reassign = "Re-assign",
    Attach = "Attach",
    New = "New",
    Blank = "Blank",
    Link = "Link",
    Unlink = "Unlink",
    Audit = "Audit",
    Refresh = "Refresh",
    Doctor = "Doctor",
    Ellipsis = "Ellipsis",
    Billing = "Billing",
    Open = "Open",
    Erase = "Erase",
    Check = "Check",
    CheckSquare = "CheckSquare",
    Binoculars = "Binoculars",
    HandDollar = "HandDollar",
    Transfer = "Transfer",
    Trash = "Trash",
    NoIcon = "NoIcon",
    ChveronUp = "ChveronUp",
    ChveronDown = "ChveronDown",
    CreditCard = "CreditCard",
    DeferPayment = "DeferPayment",
    Clipboard = "Clipboard",
    Card = "Card",
    Filter = "Filter",
    Copy = "Copy",
    Default = "Default",
    Menu = "Menu",
    Camera = "Camera",
    ChevronLeft = "ChevronLeft",
    ChevronRight = "ChevronRight",
    CsvFile = "CsvFile",
    ToggleOn = "ToggleOn",
    ToggleOff = "ToggleOff",
}
export enum ActionButtonClass {
    Base = "btn btn-primary",
    Save = "fa-solid fa-circle-check",
    Post = "fa-solid fa-circle-check",
    Complete = "fa-solid fa-circle-check",
    Add = "fa-solid fa-circle-plus",
    Delete = "fa-solid fa-circle-xmark",
    Remove = "fa-solid fa-eraser",
    Export = "fa-solid fa-download",
    Import = "fa-solid fa-upload",
    Close = "fa-solid fa-circle-xmark",
    Report = "fa-regular fa-file",
    Edit = "fa-regular fa-pen-to-square",
    Ignore = "fa-solid fa-triangle-exclamation",
    Warning = "fa-solid fa-triangle-exclamation", 
    Reverse = "fa-solid fa-rotate-left",
    Hold = "fa-solid fa-circle-pause",
    Calendar = "fa-regular fa-calendar-days",
    Communication = "fa-solid fa-envelope",
    Receipt = "fa-solid fa-receipt",
    Invoice = "fa-solid fa-file-invoice",
    InvoiceDollar = "fa-solid fa-file-invoice-dollar",
    Statement = "fa-solid fa-file-lines",
    Send = "fa-regular fa-paper-plane",
    Excel = "fa-solid fa-file-excel",
    Print = "fa-solid fa-print",
    Setting = "fa-solid fa-gear",
    Customize = "fa-solid fa-ellipsis-vertical",
    Tools = "fa-solid fa-screwdriver-wrench",
    Search = "fa-solid fa-magnifying-glass",
    Location = "fa-solid fa-location-dot",
    Next = "fa-solid fa-forward",
    Forward = "fa-solid fa-forward-step",
    Last = "fa-solid fa-forward-fast",
    Previous = "fa-solid fa-backward",
    Backward = "fa-solid fa-backward-step",
    First = "fa-solid fa-backward-fast",
    Lock = "fa-solid fa-lock",
    Unlock = "fa-solid fa-unlock",
    Reassign = "fa-solid fa-people-arrows",
    Attach = "fa-solid fa-paperclip",
    New = "fa-solid fa-arrow-up-right-from-square",
    Blank = "fa-solid fa-gear",
    Link = "fa-solid fa-link",
    Unlink = "fa-solid fa-link-slash",
    Audit = "fa-solid fa-clock-rotate-left",
    Refresh = "fa-solid fa-rotate",
    Doctor = "fa-solid fa-user-doctor",
    Ellipsis = "fa-solid fa-ellipsis",
    Billing = "fa-solid fa-file-invoice-dollar",
    Open = "fa-solid fa-up-right-from-square",
    Erase = "fa-solid fa-eraser",
    Check = "fa-solid fa-check",
    CheckSquare = "fa-sharp fa-regular fa-square-check",
    Binoculars = "fa-solid fa-binoculars",
    Transfer="fa-solid fa-right-left",
    HandDollar = "fa-solid fa-hand-holding-dollar",
    Trash = "fa-solid fa-trash",
    ChveronUp = "fa-solid fa-chevron-up",
    ChveronDown = "fa-solid fa-chevron-down",
    CreditCard = "fa-regular fa-credit-card",
    DeferPayment = "fa-solid fa-money-bill-transfer",
    Clipboard = "fa-solid fa-clipboard",
    Card = "fa-solid fa-address-card",
    Filter = "fa-solid fa-filter",
    Copy = "fa-regular fa-copy",
    Default = "fa-solid fa-right-from-bracket",
    Menu = "fa-solid fa-bars",
    Camera = "fa-solid fa-camera",
    ChevronLeft = "fa-solid fa-chevron-left",
    ChevronRight = "fa-solid fa-chevron-right",
    CsvFile = "fa-solid fa-file-csv",
    ToggleOn = "fa-solid fa-toggle-on",
    ToggleOff = "fa-solid fa-toggle-off",
}

// TODO: Remove if we replace ActionButton.vue with ActionButtonV2.vue
export function DefaultActionButton(inputAction: IActionButton) : IActionButton  {
    inputAction.baseText = inputAction.baseText ?? inputAction.overRideStyle;
    inputAction.baseClass = inputAction.baseClass ?? ActionButtonClass.Base;
    inputAction.disabled = inputAction.disabled ?? false;
    inputAction.toolTip = inputAction.toolTip ?? inputAction.baseText;
    inputAction.spinClass = inputAction.spinClass ?? spinnerClassSmall; 
    switch (inputAction.overRideStyle) {
        case ActionButtonStyle.Save:
            inputAction.spinText = inputAction.spinText ?? "Saving";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Save;
            return inputAction; 
        case ActionButtonStyle.Post:
            inputAction.spinText = inputAction.spinText ?? "Posting";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Save;
            return inputAction; 
        case ActionButtonStyle.Complete:
            inputAction.spinText = inputAction.spinText ?? "Completing";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Save;
            return inputAction; 
        case ActionButtonStyle.Add: 
            inputAction.spinText = inputAction.spinText ?? "Adding";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Add; 
            return inputAction;  
        case ActionButtonStyle.Delete:
            inputAction.spinText = inputAction.spinText ?? "Deleting";
            inputAction.iconClass = inputAction.iconClass ?? `${ActionButtonClass.Delete} text-danger`;
            return inputAction;  
        case ActionButtonStyle.Remove:
            inputAction.spinText = inputAction.spinText ?? "Removing";
            inputAction.iconClass = inputAction.iconClass ?? `${ActionButtonClass.Remove} text-danger`;
            return inputAction;
        case ActionButtonStyle.Export:
            inputAction.spinText = inputAction.spinText ?? "Exporting";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Export;
            return inputAction; 
        case ActionButtonStyle.Import:
            inputAction.spinText = inputAction.spinText ?? "Importing";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Import
            return inputAction;   
        case ActionButtonStyle.Close:
            inputAction.spinText = inputAction.spinText ?? "Closing";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Close;
            inputAction.spinClass = "";
            return inputAction;   
        case ActionButtonStyle.Report:
            inputAction.spinText = inputAction.spinText ?? "Reporting";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Report;
            return inputAction;  
        case ActionButtonStyle.Ignore:
            inputAction.spinText = inputAction.spinText ?? "Ignoring";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Warning;
            return inputAction;  
        case ActionButtonStyle.Warning:
            inputAction.spinText = inputAction.spinText ?? "Warning";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Warning;
            return inputAction;  
        case ActionButtonStyle.Edit:
            inputAction.spinText = inputAction.spinText ?? "Editing";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Edit;
            return inputAction;
        case ActionButtonStyle.Reverse:
            inputAction.spinText = inputAction.spinText ?? "Reversing";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Reverse;
            return inputAction;
        case ActionButtonStyle.Hold:
            inputAction.spinText = inputAction.spinText ?? "Holding";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Hold;
            return inputAction;
        case ActionButtonStyle.Calendar: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Calendar;
            return inputAction;
        case ActionButtonStyle.Communication: 
            inputAction.spinText = inputAction.spinText ?? "Communicating";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Communication;
            return inputAction;
        case ActionButtonStyle.Receipt: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Receipt;
            return inputAction;
        case ActionButtonStyle.Invoice: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Invoice;
            return inputAction; 
        case ActionButtonStyle.Transfer: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Transfer;
            return inputAction;
        case ActionButtonStyle.HandDollar: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.HandDollar;
            return inputAction;
        case ActionButtonStyle.InvoiceDollar: 
             inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.InvoiceDollar;
            return inputAction;
        case ActionButtonStyle.Statement: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Statement;
            return inputAction;
        case ActionButtonStyle.Send: 
            inputAction.spinText = inputAction.spinText ?? "Sending";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Send;
            return inputAction; 
        case ActionButtonStyle.Excel: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Excel;
            return inputAction;
        case ActionButtonStyle.Print: 
            inputAction.spinText = inputAction.spinText ?? "Printing";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Print;
            return inputAction; 
        case ActionButtonStyle.Setting: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Setting;
            return inputAction; 
        case ActionButtonStyle.Customize: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Customize;
            return inputAction;  
        case ActionButtonStyle.Tools: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Tools;
            return inputAction; 
        case ActionButtonStyle.Search: 
            inputAction.spinText = inputAction.spinText ?? "Searching";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Search;
            return inputAction;
        case ActionButtonStyle.Location: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Location;
            return inputAction;
        case ActionButtonStyle.Next: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Next;
            return inputAction;
        case ActionButtonStyle.Forward: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Forward;
            return inputAction;
        case ActionButtonStyle.Last: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Last;
            return inputAction;
        case ActionButtonStyle.Previous: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Previous;
            return inputAction;
        case ActionButtonStyle.Backward: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Backward;
            return inputAction;
        case ActionButtonStyle.First: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.First;
            return inputAction;
        case ActionButtonStyle.Lock: 
            inputAction.spinText = inputAction.spinText ?? "Locking";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Lock;
            return inputAction;
        case ActionButtonStyle.Unlock: 
            inputAction.spinText = inputAction.spinText ?? "Unlocking";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Unlock;
            return inputAction;
        case ActionButtonStyle.Reassign: 
            inputAction.spinText = inputAction.spinText ?? "Re-assigning";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Reassign;
            return inputAction; 
        case ActionButtonStyle.Attach: 
            inputAction.spinText = inputAction.spinText ?? "Attaching";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Attach;
            return inputAction; 
        case ActionButtonStyle.New: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.New;
            return inputAction; 
        case ActionButtonStyle.Blank:
            inputAction.baseText = "";
            inputAction.spinText = "";
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Blank;
            return inputAction; 
        case ActionButtonStyle.Erase: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Erase;
            return inputAction; 
        case ActionButtonStyle.Trash:
            inputAction.spinText = inputAction.spinText ?? "Deleting";
            inputAction.iconClass = inputAction.iconClass ?? `${ActionButtonClass.Trash} text-danger`;
            return inputAction;  
        case ActionButtonStyle.ChveronDown: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.ChveronDown;
            return inputAction;
        case ActionButtonStyle.ChveronUp: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.ChveronUp;
            return inputAction;
        case ActionButtonStyle.CreditCard: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.CreditCard;
            return inputAction;
        case ActionButtonStyle.DeferPayment: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.DeferPayment;
            return inputAction;
        case ActionButtonStyle.Clipboard:
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Clipboard;
            inputAction.baseText = "";
            return inputAction;
        case ActionButtonStyle.Card:
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Card;
            inputAction.baseText = "";
            return inputAction;
        case ActionButtonStyle.Filter:
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Filter;
            inputAction.baseText = "";
            return inputAction;
        case ActionButtonStyle.Copy:
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Copy;
            inputAction.baseText = "";
            return inputAction;
        case ActionButtonStyle.Default:
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Default;
            inputAction.baseText = "";
            return inputAction;
        case ActionButtonStyle.Menu:
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Menu;
            inputAction.baseText = "";
            return inputAction;
        case ActionButtonStyle.Camera:
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.Camera;
            inputAction.baseText = "";
            return inputAction;
        case ActionButtonStyle.ChevronLeft: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.ChevronLeft;
            inputAction.baseText = "";
            return inputAction;
        case ActionButtonStyle.ChevronRight: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.ChevronRight;
            inputAction.baseText = "";
            return inputAction;
        case ActionButtonStyle.CsvFile: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.CsvFile;
            inputAction.baseText = "";
            return inputAction; 
        case ActionButtonStyle.ToggleOn: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.ToggleOn;
            inputAction.baseText = "";
            return inputAction; 
        case ActionButtonStyle.ToggleOff: 
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
            inputAction.iconClass = inputAction.iconClass ?? ActionButtonClass.ToggleOff;
            inputAction.baseText = "";
            return inputAction; 
        default:
            inputAction.spinText = inputAction.spinText ?? inputAction.baseText;
    }
    return  inputAction;
}

export function DefaultActionButtonValues(inputAction: ActionButtonStyle) : { spinText?: string, iconClass?: string, spinClass?: string, baseText?: string } {

    const defaultValues: Record<ActionButtonStyle|string, { spinText?: string, iconClass?: string, spinClass?: string, baseText?: string }> = {
        [ActionButtonStyle.Save]: { spinText: "Saving", iconClass: ActionButtonClass.Save },
        [ActionButtonStyle.Post]: { spinText: "Posting", iconClass: ActionButtonClass.Save },
        [ActionButtonStyle.Complete]: { spinText: "Completing", iconClass: ActionButtonClass.Save },
        [ActionButtonStyle.Add]: {spinText: "Adding", iconClass: ActionButtonClass.Add },
        [ActionButtonStyle.Delete]: {spinText: "Deleting", iconClass: ActionButtonClass.Delete },
        [ActionButtonStyle.Remove]: {spinText: "Removing", iconClass: ActionButtonClass.Remove },
        [ActionButtonStyle.Export]: {spinText: "Exporting", iconClass: ActionButtonClass.Export },
        [ActionButtonStyle.Import]: {spinText: "Importing", iconClass: ActionButtonClass.Import },
        [ActionButtonStyle.Close]: {spinText: "Closing", iconClass: ActionButtonClass.Close, spinClass: "" },
        [ActionButtonStyle.Report]: {spinText: "Reporting", iconClass: ActionButtonClass.Report },
        [ActionButtonStyle.Ignore]: {spinText: "Ignoring", iconClass: ActionButtonClass.Ignore },
        [ActionButtonStyle.Warning]: {spinText: "Warning", iconClass: ActionButtonClass.Warning },
        [ActionButtonStyle.Edit]: {spinText: "Editing", iconClass: ActionButtonClass.Edit },
        [ActionButtonStyle.Reverse]: {spinText: "Reversing", iconClass: ActionButtonClass.Reverse },
        [ActionButtonStyle.Hold]: {spinText: "Holding", iconClass: ActionButtonClass.Hold },
        [ActionButtonStyle.Calendar]: { iconClass: ActionButtonClass.Calendar },
        [ActionButtonStyle.Communication]: {spinText: "Communicating", iconClass: ActionButtonClass.Communication },
        [ActionButtonStyle.Receipt]: { iconClass: ActionButtonClass.Receipt },
        [ActionButtonStyle.Invoice]: { iconClass: ActionButtonClass.Invoice },
        [ActionButtonStyle.InvoiceDollar]: { iconClass: ActionButtonClass.InvoiceDollar },
        [ActionButtonStyle.Statement]: { spinText: "", iconClass: ActionButtonClass.Statement },
        [ActionButtonStyle.Send]: { spinText: "Sending", iconClass: ActionButtonClass.Send },
        [ActionButtonStyle.Excel]: { iconClass: ActionButtonClass.Excel },
        [ActionButtonStyle.Print]: { spinText: "Printing", iconClass: ActionButtonClass.Print },
        [ActionButtonStyle.Setting]: { iconClass: ActionButtonClass.Setting },
        [ActionButtonStyle.Customize]: { iconClass: ActionButtonClass.Customize },
        [ActionButtonStyle.Tools]: { iconClass: ActionButtonClass.Tools },
        [ActionButtonStyle.Search]: { spinText: "Searching", iconClass: ActionButtonClass.Search },
        [ActionButtonStyle.Location]: { iconClass: ActionButtonClass.Location },
        [ActionButtonStyle.Next]: { iconClass: ActionButtonClass.Next },
        [ActionButtonStyle.Forward]: { iconClass: ActionButtonClass.Forward },
        [ActionButtonStyle.Last]: { iconClass: ActionButtonClass.Last },
        [ActionButtonStyle.Previous]: { iconClass: ActionButtonClass.Previous },
        [ActionButtonStyle.Backward]: { iconClass: ActionButtonClass.Backward },
        [ActionButtonStyle.First]: { iconClass: ActionButtonClass.First },
        [ActionButtonStyle.Lock]: { spinText: "Locking", iconClass: ActionButtonClass.Lock },
        [ActionButtonStyle.Unlock]: { spinText: "Unlocking", iconClass: ActionButtonClass.Unlock },
        [ActionButtonStyle.Reassign]: { spinText: "Re-assigning", iconClass: ActionButtonClass.Reassign },
        [ActionButtonStyle.Attach]: { spinText: "Attaching", iconClass: ActionButtonClass.Attach },
        [ActionButtonStyle.New]: { iconClass: ActionButtonClass.New },
        [ActionButtonStyle.Blank]: { baseText:"", spinText:"", iconClass: ActionButtonClass.Blank },
        [ActionButtonStyle.Link]: { baseText: "Link", iconClass:ActionButtonClass.Link },
        [ActionButtonStyle.Unlink]: { baseText: "Link", iconClass:ActionButtonClass.Unlink },
        [ActionButtonStyle.Audit]: { baseText: "Audit", iconClass:ActionButtonClass.Audit },
        [ActionButtonStyle.Refresh]: { baseText: "Refresh", iconClass:ActionButtonClass.Refresh },
        [ActionButtonStyle.Doctor]: { baseText: "Doctor", iconClass:ActionButtonClass.Doctor },
        [ActionButtonStyle.Ellipsis]: { baseText: "More", iconClass:ActionButtonClass.Ellipsis },
        [ActionButtonStyle.Billing]: { baseText: "Billing", iconClass:ActionButtonClass.Billing },
        [ActionButtonStyle.Open]: { baseText: "Open", iconClass:ActionButtonClass.Open },
        [ActionButtonStyle.Erase]: { baseText: "Erase", iconClass:ActionButtonClass.Erase },
        [ActionButtonStyle.Check]: { baseText: "Check", iconClass:ActionButtonClass.Check },
        [ActionButtonStyle.CheckSquare]: { baseText: "CheckSquare", iconClass:ActionButtonClass.CheckSquare },
        [ActionButtonStyle.Binoculars]: { baseText: "Binoculars", iconClass:ActionButtonClass.Binoculars },
        [ActionButtonStyle.Trash]: {spinText: "Deleting", iconClass: ActionButtonClass.Trash },
        [ActionButtonStyle.NoIcon]: { baseText: "", iconClass: undefined },
        [ActionButtonStyle.ChveronDown]: { iconClass: ActionButtonClass.ChveronDown },
        [ActionButtonStyle.ChveronUp]: { iconClass: ActionButtonClass.ChveronUp },
        [ActionButtonStyle.Clipboard]: { iconClass: ActionButtonClass.Clipboard },
        [ActionButtonStyle.CreditCard]: { iconClass: ActionButtonClass.CreditCard },
        [ActionButtonStyle.DeferPayment]: { iconClass: ActionButtonClass.DeferPayment },
        [ActionButtonStyle.Card]: { iconClass: ActionButtonClass.Card },
        [ActionButtonStyle.Filter]: { iconClass: ActionButtonClass.Filter },
        [ActionButtonStyle.Copy]: { iconClass: ActionButtonClass.Copy },
        [ActionButtonStyle.Default]: { iconClass: ActionButtonClass.Default },
        [ActionButtonStyle.Menu]: { iconClass: ActionButtonClass.Menu },
        [ActionButtonStyle.Camera]: { iconClass: ActionButtonClass.Camera },
        [ActionButtonStyle.ChevronLeft]: { iconClass: ActionButtonClass.ChevronLeft },
        [ActionButtonStyle.ChevronRight]: { iconClass: ActionButtonClass.ChevronRight },
        [ActionButtonStyle.CsvFile]: { iconClass: ActionButtonClass.CsvFile },
        [ActionButtonStyle.ToggleOn]: { iconClass: ActionButtonClass.ToggleOn },
        [ActionButtonStyle.ToggleOff]: { iconClass: ActionButtonClass.ToggleOff },
    };
    return defaultValues[inputAction];
}
 
   